import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';

/**
 * VAT 15% calculation cards — toggleable section on the dashboard.
 * Three cards: Output VAT, Input VAT, VAT Payable. Pure presentational.
 */
export const VATSummaryCards = ({ stats, showVat, onToggleVat }) => {
  return (
    <>
      <div className="flex items-center gap-3 mt-2">
        <Checkbox
          checked={showVat}
          onCheckedChange={onToggleVat}
          id="vat-toggle"
          data-testid="vat-toggle"
        />
        <Label htmlFor="vat-toggle" className="cursor-pointer text-sm font-medium">
          Show VAT 15% Calculation
        </Label>
      </div>
      {showVat && (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-testid="vat-summary-cards">
          <Card className="border-border bg-info/10 border-info/30">
            <CardHeader className="pb-2">
              <CardTitle className="text-xs text-muted-foreground">VAT on Sales (Output)</CardTitle>
            </CardHeader>
            <CardContent>
              <div className="text-2xl font-bold font-outfit text-info">
                SR {(stats?.vat_on_sales || 0).toFixed(2)}
              </div>
              <p className="text-xs text-muted-foreground mt-1">
                Recorded on sales · net sales SR {(stats?.total_sales || 0).toFixed(0)}
              </p>
            </CardContent>
          </Card>
          <Card className="border-border bg-success/10 border-success/30">
            <CardHeader className="pb-2">
              <CardTitle className="text-xs text-muted-foreground">VAT on Purchases (Input)</CardTitle>
            </CardHeader>
            <CardContent>
              <div className="text-2xl font-bold font-outfit text-success">
                SR {(stats?.vat_on_purchases || 0).toFixed(2)}
              </div>
              <p className="text-xs text-muted-foreground mt-1">
                Recorded input VAT on purchases &amp; expenses
              </p>
            </CardContent>
          </Card>
          <Card className="border-border bg-orange-50 border-orange-200">
            <CardHeader className="pb-2">
              <CardTitle className="text-xs text-muted-foreground">VAT Payable</CardTitle>
            </CardHeader>
            <CardContent>
              <div className="text-2xl font-bold font-outfit text-orange-600">
                SR {(stats?.vat_payable || 0).toFixed(2)}
              </div>
              <p className="text-xs text-muted-foreground mt-1">Output VAT - Input VAT</p>
            </CardContent>
          </Card>
        </div>
      )}
    </>
  );
};

export default VATSummaryCards;
